export const TASK_CSV_COLUMNS = ['Description', 'AssessorGuideline'] as const;

export const TASK_CSV_HEADER = TASK_CSV_COLUMNS.join('^');

export const TASK_CSV_TEMPLATE = [
    TASK_CSV_HEADER,
    'Verify safety equipment is properly stowed^Check that all safety equipment is secured and accessible',
    'Complete pre-departure checklist^Ensure all items on checklist are marked and verified',
].join('\n');

export const TASK_CSV_FIELD = {
    description: 0,
    guideline: 1,
} as const;

export const TASK_CSV_EXPECTED_COLUMN_COUNT = TASK_CSV_COLUMNS.length;
export const TASK_CSV_IMPORT_STATUS_SUCCESS = 'success';
export const TASK_CSV_IMPORT_STATUS_PARTIAL = 'partial';
export const TASK_CSV_IMPORT_STATUS_FAILED = 'failed';
export const TASK_CSV_TEMPLATE_FILE_NAME = 'task-template.csv';
export const TASK_CSV_ISSUES_FILE_NAME = 'task-import-errors.csv';
